"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTrafficLayer = exports.useStoreMapAndPlatform = exports.useRetheme = exports.useResizeMapWithWindow = exports.useCenterAndZoom = exports.useAddMapListeners = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// This effect handles updating center and zoom of a loaded map
var useCenterAndZoom = function useCenterAndZoom(map, mapConfig) {
  (0, _react.useEffect)(function () {
    if (map && mapConfig) {
      map.setZoom(mapConfig.zoom);
      map.setCenter(mapConfig.center);
    }
  }, [map, mapConfig]);
};

// Helper function for: useResizeMapWithWindow
exports.useCenterAndZoom = useCenterAndZoom;
function resizeHereMap(map) {
  map === null || map === void 0 ? void 0 : map.getViewPort().resize();
}

// This effect handles resizing the map when the window is resized
var useResizeMapWithWindow = function useResizeMapWithWindow(map) {
  (0, _react.useEffect)(function () {
    if (map) {
      window.addEventListener('resize', function () {
        resizeHereMap(map);
      });
      return function () {
        window.removeEventListener('resize', function () {
          resizeHereMap(map);
        });
      };
    }
  }, [map]);
};
exports.useResizeMapWithWindow = useResizeMapWithWindow;
var useRetheme = function useRetheme(theme, map, platform) {
  (0, _react.useEffect)(function () {
    if (!theme || !map || !platform) return;
    var H = window.H;
    var defaultLayers = platform.createDefaultLayers({
      engineType: H.Map.EngineType.HARP
    });
    if (theme.includes("normal")) {
      if (theme.includes("night")) {
        map.setBaseLayer(theme.includes("vector") ? defaultLayers.vector.normal.mapnight : defaultLayers.raster.normal.mapnight);
      } else map.setBaseLayer(theme.includes("vector") ? defaultLayers.vector.normal.map : defaultLayers.raster.normal.map);
    } else if (theme.includes("satellite")) {
      map.setBaseLayer(defaultLayers.raster.satellite.map);
    } else if (theme.includes("terrain")) {
      map.setBaseLayer(defaultLayers.raster.terrain.map);
    } else {
      map.setBaseLayer(theme.includes("vector") ? defaultLayers.vector.normal.map : defaultLayers.raster.normal.map);
    }
  }, [theme, map, platform]);
};
exports.useRetheme = useRetheme;
var useTrafficLayer = function useTrafficLayer() {
  var showTraffic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var map = arguments.length > 1 ? arguments[1] : undefined;
  var platform = arguments.length > 2 ? arguments[2] : undefined;
  var useVectorTiles = arguments.length > 3 ? arguments[3] : undefined;
  var trafficLayerRef = _react.default.useRef(null);
  (0, _react.useEffect)(function () {
    if (map && platform) {
      if (trafficLayerRef.current) map.removeLayer(trafficLayerRef.current);
      var _H = window.H;

      // Create a new traffic layer based on the type
      var newTrafficLayer = null;
      if (useVectorTiles) {
        var providerTrafficFlow = new _H.service.trafficVectorTile.Provider(platform.getTrafficVectorTileService({
          layer: "flow"
        }), new _H.map.render.harp.Style({}), {
          engineType: _H.Map.EngineType.HARP
        });
        newTrafficLayer = new _H.map.layer.TileLayer(providerTrafficFlow, {
          min: 2,
          max: 24
        });
      } else {
        newTrafficLayer = platform.createDefaultLayers({
          engineType: _H.Map.EngineType.HARP
        }).vector.traffic.map;
      }

      // Add the new traffic layer if showTraffic is true
      if (showTraffic && newTrafficLayer) {
        map.addLayer(newTrafficLayer, 100);
        trafficLayerRef.current = newTrafficLayer; // Save the current traffic layer
      }
    }

    // Cleanup function to remove the traffic layer when the component unmounts
    return function () {
      if (trafficLayerRef.current) {
        map === null || map === void 0 ? void 0 : map.removeLayer(trafficLayerRef.current);
        trafficLayerRef.current = null; // Reset the ref
      }
    };
  }, [showTraffic, map, platform, useVectorTiles]); // Dependencies

  return trafficLayerRef.current; // Return the current traffic layer
};

// This effect handles adding (and cleaning up) map listeners
exports.useTrafficLayer = useTrafficLayer;
var useAddMapListeners = function useAddMapListeners(map, listeners) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    added = _useState2[0],
    setAdded = _useState2[1];
  (0, _react.useEffect)(function () {
    if (map && listeners && !added) {
      // add listeners
      listeners.map(function (listener) {
        map.addEventListener(listener.type, function (evt) {
          return listener.action(evt, map);
        });
      });
      setAdded(true);
      return function () {
        // remove listeners
        listeners === null || listeners === void 0 ? void 0 : listeners.map(function (listener) {
          map && map.removeEventListener(listener.type, function (evt) {
            return listener.action(evt, map);
          });
        });
      };
    }
  }, [map, listeners, added]);
};

// This effect handles passing parent a reference to 'map' object
exports.useAddMapListeners = useAddMapListeners;
var useStoreMapAndPlatform = function useStoreMapAndPlatform(map, platform, callback) {
  (0, _react.useEffect)(function () {
    if (map && platform && callback) callback(map, platform);
  }, [map, platform]);
};
exports.useStoreMapAndPlatform = useStoreMapAndPlatform;